import React, { FC } from "react";
import styled from "styled-components";
import { text } from "../lib/sharedStyles";
import { ContentfulTextPair } from "../lib/contentfulTypes";

const Container = styled.div`
  margin-bottom: 80px;

  @media (min-width: 993px) {
    grid-gap: 16px;
    margin-bottom: 120px;
  }
`;

const Item = styled.div`
  background-color: #F5F5F5;
  padding: 40px 65px 50px 40px;
  margin-bottom: 16px;
  border-radius: 16px;
  height: 100%;

  @media (min-width: 993px) {
    margin-bottom: 0;
  }

  hr {
    margin: 0;
    width: 40px;
    height: 2px;
    background-color: #0083FF;
  }

  p {
    margin: 0;

    &:nth-of-type(1) {
      ${text(500, '24px', '28px', '#1A1B1B')}
      margin: 40px 0 24px;
    }

    &:nth-of-type(2) {
      ${text(400, '14px', '22px', '#1A1B1B')}
    }
  }
`;

const TextPairComponent: FC<ContentfulTextPair> = ({ fields }) => {
  const { primaryText, secondaryText, optionalImage } = fields;

  return (
    <Container>
      <Item>
        <hr />
        {optionalImage && <img src={`https:${optionalImage.fields.file?.url}`} alt={`${optionalImage.fields.file?.fileName}`}/>}
        {primaryText && <p>{primaryText}</p>}
        {secondaryText && <p>{secondaryText}</p>}
      </Item>
    </Container>
  );
};

export default TextPairComponent;
